"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get = _interopRequireDefault(require("lodash/get"));

var SingleplatformDataSource =
/*#__PURE__*/
function () {
  function SingleplatformDataSource() {
    (0, _classCallCheck2["default"])(this, SingleplatformDataSource);
  }

  (0, _createClass2["default"])(SingleplatformDataSource, null, [{
    key: "getName",
    value: function getName() {
      return 'SinglePlatform';
    }
  }, {
    key: "getItemId",
    value: function getItemId(item) {
      return item.id;
    }
  }, {
    key: "mapResult",
    value: function mapResult(result) {
      if (result) {
        result = result.data;
        return result.splice(0, 20);
      }

      return [];
    }
  }, {
    key: "resolvePath",
    value: function resolvePath(mappedResult, dataPath) {
      var menu = mappedResult.find(function (item) {
        return item.id === dataPath;
      });

      if (!menu) {
        return false;
      }

      var result = [];
      menu.sections.forEach(function (subMenu) {
        result.push({
          title: subMenu.name,
          description: subMenu.description,
          _type: 'header'
        });
        subMenu.items.forEach(function (item) {
          var choices = item.choices && item.choices.length > 1 && item.choices.map(function (choice) {
            return {
              name: choice.name,
              price: choice.prices && (choice.prices.min || choice.prices.max)
            };
          });
          result.push({
            title: item.name,
            description: item.description,
            price: (0, _get["default"])(item, 'choices[0].prices.min'),
            choices: choices
          });
        });
      });
      return result;
    }
  }, {
    key: "getDataPromise",
    value: function getDataPromise(value, requestBody) {
      var item = [{
        id: 'spId',
        value: value
      }];
      requestBody.item = item;
      return requestBody;
    }
  }]);
  return SingleplatformDataSource;
}();

SingleplatformDataSource.getRequestParameters = function (singleplatformId) {
  return {
    template: 'spId:' + singleplatformId
  };
};

SingleplatformDataSource.getRequestName = function () {
  return 'singlePlatformmenuapi';
};

var _default = SingleplatformDataSource;
exports["default"] = _default;